import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { CasePreview, PlaceholderLoader } from '../index.js';
const CasePreviewByCaseId = (props) => {
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    return singleCase ? (React.createElement(CasePreview, { ...props, caseId: singleCase.caseId })) : (React.createElement(PlaceholderLoader, null));
};
export default CasePreviewByCaseId;
//# sourceMappingURL=CasePreviewByCaseId.js.map